// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-main-banner__item{overflow:hidden}.c-main-banner__item img{font-size:0;color:transparent;margin:0 auto;transition:opacity .6s ease-in-out;will-change:opacity}.c-main-banner__item img:not(.swiper-lazy-loaded){opacity:0}.c-main-banner__item:focus-visible{outline-offset:-3px}", ""]);
// Exports
module.exports = exports;
